export default __webpack_public_path__ + "static/broken-20fed5ed9a84ba71a819dfc07ddc6e1d.png";